/**
 * Helper para exportar arrays de objetos a CSV que se descarga
 * inmediatamente. Sin dependencias externas.
 *
 *   exportCSV("profesionales.csv", rows, [
 *     { key: "name",   label: "Nombre" },
 *     { key: "comuna", label: "Comuna" },
 *   ]);
 */
function _escape(val) {
  if (val === null || val === undefined) return "";
  const s = String(val);
  if (/[",\n;]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

export function toCSV(rows, columns) {
  const header = columns.map((c) => _escape(c.label ?? c.key)).join(",");
  const body = (rows || [])
    .map((r) => columns.map((c) => _escape(typeof c.format === "function" ? c.format(r[c.key], r) : r[c.key])).join(","))
    .join("\n");
  return `${header}\n${body}`;
}

export function downloadCSV(filename, rows, columns) {
  const csv = toCSV(rows, columns);
  // BOM \uFEFF para que Excel abra UTF-8 correctamente (ñ, tildes)
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
